<template>
    <tailwind-layout title="Property Payment">
        <div class="bg-white border border-gray-200 shadow-xl sm:rounded-lg p-6 mt-9">
            <div class="text-center">
                <h1 class="text-2xl font-bold text-blue-600 mb-4">{{message}}</h1>
            </div>
        </div>
    
    <!-- Demo Widget -->
    <DemoWidget
        :page-identifier="'rented-properties.payment-failed'"
        :steps="demoSteps"
        :auto-start="true"
        :show-help-icon="true"
    />
    </tailwind-layout>
</template>

<script>
import TailwindLayout from '@/Layouts/TailwindLayout.vue';
import DemoWidget from '@/Components/DemoWidget.vue'
import { getDemoSteps } from '@/Config/demoSteps.js'
import FormButton from '@/Shared/FormButton.vue';
import SelectInput from '@/Shared/SelectInput.vue';
import SwitchGroup from "@/Shared/SwitchGroup.vue";
import RadioGroup from "@/Shared/RadioGroup.vue";
import BannedCitiesAndStates from "@/Shared/BannedCitiesAndStates.vue";
import axios from "axios";

export default {
    props: {
        message: String,
    },
    components: {
        TailwindLayout,
        FormButton,
        SelectInput,
        RadioGroup,
        DemoWidget
    },
    remember: 'form',
    data() {
        return {
            demoSteps: getDemoSteps('rented-properties.payment-failed')
        }
    }
}
</script>
